// Copyright 2026, Imprivata, Inc.  All rights reserved.

export const OIDC_IDP_FLOW = 'standard-oidc';
export const EPIC_HYPERDRIVE_PRODUCT_ID = 'epic-hyperdrive';
export const ACR_SSO = 'com:imprivata:oidc:epic:sso';
export const ACR_EPCS = 'com:imprivata:oidc:epic:cw:epcs';

export const NO_WAVE = { disabled: true } as const;
